
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bureau-a-l-heure/[zone]",
      function () {
        return require("private-next-pages/bureau-a-l-heure/[zone].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bureau-a-l-heure/[zone]"])
      });
    }
  